import { PageHeader } from "../components/PageHeader";
import { Seo, breadcrumbSchema } from "../components/Seo";
import { ServicesGrid, ProcessTimeline, IndustriesGrid, CtaSection, Ribbon } from "../components/Sections";

const SCHEMA = breadcrumbSchema([["Home", "/"], ["Services", "/services"]]);

export default function Services() {
  return (
    <>
      <Seo
        title="Talent Solutions & Services"
        description="IT and Non-IT recruitment, contract and permanent staffing, RPO services and executive search — one talent partner for every hiring need."
        keywords="IT Recruitment Services, Non-IT Recruitment, Contract Staffing, Permanent Staffing, RPO Services, Executive Search India"
        schema={SCHEMA}
      />
      <PageHeader kicker="Our Talent Solutions" title="Recruitment & staffing, engineered for outcomes"
        sub="IT and Non-IT recruitment, contract and permanent staffing, RPO and executive search — one partner for every hiring need." />
      <ServicesGrid showHeading={false} />
      <Ribbon />
      <ProcessTimeline />
      <IndustriesGrid />
      <CtaSection />
    </>
  );
}
